import { useMutation } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";

type StoredToken = { AccessToken?: string };

export type TestSendStepResult = {
  step_id: string;
  awarded_count: number;
};

export type TestSendRecipientResult = {
  recipient: string;
  user_id: string;
  // Optional because a backend without BONENG-1093 omits it; callers fall back
  // to the single step that such a backend delivers.
  steps?: TestSendStepResult[];
  awarded_count: number;
};

export type TestSendResult = {
  campaign_id: string;
  sent_count: number;
  recipients: TestSendRecipientResult[];
  invalid_recipients: string[];
};

async function postTestSend(campaignId: string, recipients: string[]): Promise<TestSendResult> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.TEST_SEND_DYNAMIC_BONUS_CAMPAIGN.replace("{campaign_id}", campaignId);
  const response = await instance.post(url, { recipients });
  const result = bonusAdminBody<TestSendResult>(response);
  if (!result) {
    throw new Error("Empty test-send response");
  }
  return result;
}

export const useTestSendCampaign = (campaignId: string) =>
  useMutation<TestSendResult, Error, string[]>({
    mutationFn: (recipients) => postTestSend(campaignId, recipients),
  });
